(function () {
  function initScrollImageReveal(scope) {
    const root = scope && scope.nodeType === 1 ? scope : document;
    const items = root.querySelectorAll(
      "[data-scroll-image-reveal]:not([data-reveal-initialized])"
    );
    if (!items.length) return;

    const grouped = new Map();
    items.forEach((el) => {
      el.setAttribute("data-reveal-initialized", "");
      const section = el.closest(".shopify-section");
      const key = section || root;
      if (!grouped.has(key)) grouped.set(key, []);
      grouped.get(key).push(el);
    });

    grouped.forEach((elements, sectionOrRoot) => {
      const observers = [];

      elements.forEach((el, index) => {
        const threshold = parseFloat(el.dataset.revealThreshold || "0.4");
        const baseDelay = parseInt(el.dataset.revealDelay || "500", 10);

        const isSequence = el.hasAttribute("data-reveal-sequence");
        const delay = isSequence ? baseDelay + index * 200 : baseDelay;

        const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
    }
  });
}, { threshold: 0.1 }); // this controls when fade triggers

    const images = block.querySelectorAll('.fade-image');
images.forEach((img, index) => {
  const threshold = index === 1 ? 0.5 : 0.1; // 0.5 for image 2 (index 1)
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold });
  observer.observe(img);
});

        observer.observe(el);
        observers.push(observer);
      });

      if (
        sectionOrRoot.classList &&
        sectionOrRoot.classList.contains("shopify-section")
      ) {
        sectionOrRoot.addEventListener(
          "shopify:section:unload",
          () => {
            observers.forEach((o) => o.disconnect());
          },
          { once: true }
        );
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initScrollImageReveal(document);
  });

  document.addEventListener("shopify:section:load", (event) => {
    if (!window.Shopify || !window.Shopify.designMode) return;
    initScrollImageReveal(event.target);
  });
})();
